'use client'

import { POINTS_ENABLED } from '@/config/consts'
import { cn } from '@/ui/utils/style'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const tabs: { label: string; href: string }[] = [
  ...(POINTS_ENABLED ? [{ label: 'Where to earn', href: '/points/earn' }] : []),
  { label: 'Season Mew', href: '/points' },
  { label: 'Season One', href: '/points/season-one' },
]

export function PointsNavigation() {
  const pathname = usePathname()

  return (
    <div className="mb-4 flex gap-4">
      {tabs.map(({ label, href }) => (
        <div key={href} className="flex items-center gap-2">
          <Link
            href={href}
            className={cn('inline-block border-transparent border-b-2 pb-4', {
              'cursor-pointer text-muted-foreground': pathname !== href,
              'border-primary text-primary': pathname === href,
            })}
          >
            {label}
          </Link>
        </div>
      ))}
    </div>
  )
}
